<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-one">
        <div class="page">
        </div>
        <p class="slogan">益通天下，华盛四方</p>
        <p class="slogan-sub">专注新能源电池管理系统 · 引领行业技术创新</p>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-two">
        <div class="page">
          <h3>主营业务</h3>
          <p>MAIN BUSINESS</p>
          <div class="section-line"></div>
        </div>
        <ul class="case-item">
          <li v-for="(item) in caseList" :key="item.Id" class="case-item-li"
            :style="{ backgroundImage: `url(${isLocalImage(item.Img) ? require(`@/assets/img/${item.Img}`) : item.Img})` }">
            <div class="case-item-overlay"></div>
            <div class="case-item-content">
              <p class="case-item-title">{{ item.Title }}</p>
            </div>
          </li>
        </ul>
      </swiper-slide>

      <swiper-slide class="swiper-slide slide-three">
        <div class="page">
          <h3>最新资讯</h3>
          <p>LATEST NEWS</p>
          <div class="section-line"></div>
        </div>
        <div class="news-content">
          <div class="news-content-item" v-for="(news, i) in newsList" :key="i"
            @click="goToNewsDetail(i)">
            <div :style="'order: ' + (i % 2 == 0 ? 1 : 3)">
              <div class="item-img-wrapper">
                <div class="item-img" v-lazy:background-image="isLocalImage(news.Img) ? require(`@/assets/img/${news.Img}`) : news.Img"></div>
              </div>
            </div>
            <div style="order: 2">
              <el-divider>
                <i class="el-icon-news"></i>
              </el-divider>
            </div>
            <div class="item-content" :style="'order: ' + (i % 2 == 0 ? 3 : 1)">
              <h3>{{ news.Title }}</h3>
              <p>{{ news.Content }}</p>
              <span><i class="el-icon-time"></i> {{ news.CreateTime }}</span>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <!-- 版权信息 -->
    <div class="copyright">
      <span>深圳益华通盛能源动力科技有限公司版权所有</span>
      <span>粤ICP备2025367544号-1</span>
      <span>服务名称：益华通盛能源动力科技</span>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      caseList: [
        { Id: "1", Img: "https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770886746049_981_business1.png", Title: "叉车BMS" },
        { Id: "2", Img: "https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770886768350_99_business2.png", Title: "船舶BMS" },
        { Id: "3", Img: "https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770886788186_947_business3.png", Title: "储能BMS" },
        { Id: "4", Img: "https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770886804137_216_business4.png", Title: "重卡BMS" },
        { Id: "5", Img: "https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770886822932_208_business5.png", Title: "电摩BMS" },
        { Id: "6", Img: "https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770886911707_987_business6.png", Title: "云平台小程序" },
        { Id: "7", Img: "https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770887359002_475_business7.png", Title: "高尔夫球车BMS" },
        { Id: "8", Img: "https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770887146525_161_business8.png", Title: "环卫车BMS" },
        { Id: "9", Img: "https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770887323677_918_business9.png", Title: "观光车BMS" },
      ],
      newsList: [{
        Title: "整机装车测试",
        Content: "前往安徽宣城参加整机装车测试，对S628系列智能BMS进行实地验证",
        Img:"https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770886034561_67_active1.png",
        CreateTime: "2025-02-10"
      },
      {
        Title: "批量测试",
        Content: "完成S618系列产品批量生产测试，共计200台，一次通过率超98%",
        Img:"https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770886048869_279_active2.png",
        CreateTime: "2025-02-13"
      },
      {
        Title: "高低温环境测试",
        Content: "在专业测试厂房进行-40°C至85°C高低温测试，验证产品可靠性",
        Img:"https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770886067235_301_active3.png",
        CreateTime: "2025-02-17"
      }],
      swiperOption: {
        notNextTick: true,
        direction: "vertical",
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        slidesPerView: 1,
        mousewheel: true,
        mousewheelControl: true,
        height: window.innerHeight - 60,
        resistanceRatio: 0,
        observeParents: true
      }
    };
  },
  created() { },
  methods: {
    isLocalImage(imgPath) {
      return !imgPath.startsWith('http://') && !imgPath.startsWith('https://');
    },
    goToNewsDetail(index) {
      this.$router.push({ name: 'newsdetails', params: { id: index } });
    }
  },
  mounted() {
    this.loading = false;
  }
};
</script>

<style lang="scss" scoped>
.swiper-slide {
  font-size: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    text-align: center;
    overflow: hidden;

    h3 {
      font-size: 42px;
      font-weight: 600;
      color: #fff;
      text-shadow: 0 2px 10px rgba(0,0,0,0.3);
      margin-bottom: 8px;
    }

    p {
      font-size: 18px;
      font-weight: 300;
      color: rgba(255,255,255,0.85);
      letter-spacing: 4px;
    }

    .section-line {
      width: 60px;
      height: 3px;
      background: linear-gradient(90deg, transparent, #fff, transparent);
      margin: 15px auto 0;
      border-radius: 2px;
    }
  }

  .slogan {
    text-align: center;
    font-size: 56px;
    color: #fff;
    padding: 20px 0 10px;
    font-weight: 700;
    text-shadow: 0 4px 20px rgba(0,0,0,0.4);
    letter-spacing: 6px;
    animation: fadeInUp 1s ease-out;
  }

  .slogan-sub {
    text-align: center;
    font-size: 20px;
    color: rgba(255,255,255,0.9);
    font-weight: 300;
    letter-spacing: 2px;
    animation: fadeInUp 1s ease-out 0.3s both;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 主营业务
.case-item {
  width: 1200px;
  min-height: 500px;
  overflow-x: hidden;
  overflow-y: auto;
  margin: 30px auto 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 16px;
  justify-content: center;
  padding: 0 20px;

  li {
    height: 155px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.15);
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);

    &:hover {
      transform: translateY(-5px) scale(1.02);
      box-shadow: 0 12px 30px rgba(0,0,0,0.25);

      .case-item-overlay {
        background-color: rgba(26, 117, 187, 0.5);
      }
    }

    .case-item-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.35);
      transition: background-color 0.4s ease;
      z-index: 1;
    }

    .case-item-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #fff;
      z-index: 2;
    }

    .case-item-title {
      font-size: 20px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      text-shadow: 0 2px 8px rgba(0,0,0,0.4);
      letter-spacing: 2px;
    }
  }
}

.slide-one {
  background: linear-gradient(135deg, rgba(20,103,159,0.3) 0%, rgba(0,0,0,0.2) 100%),
              url(https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770885476927_804_home_top.jpg) no-repeat center;
  background-size: cover;
}

.slide-two {
  background: linear-gradient(135deg, rgba(20,103,159,0.4) 0%, rgba(0,0,0,0.3) 100%),
              url(https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770885992037_322_home_do.jpg) no-repeat center;
  background-size: cover;
}

.slide-three {
  background: linear-gradient(135deg, rgba(20,103,159,0.4) 0%, rgba(0,0,0,0.3) 100%),
              url(https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770886121163_546_home_anli.jpg) no-repeat center;
  background-size: cover;
}

//最新资讯
.news-content {
  width: 1240px;
  margin: 30px auto 0;
  display: flex;
  justify-content: center;
  gap: 30px;

  &-item {
    width: 360px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-5px);

      .item-img-wrapper {
        box-shadow: 0 12px 30px rgba(0,0,0,0.25);
      }

      .item-content {
        background-color: rgba(255,255,255,0.15);
      }
    }

    .item-img-wrapper {
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 4px 15px rgba(0,0,0,0.15);
      transition: box-shadow 0.3s ease;

      .item-img {
        width: 360px;
        height: 220px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        transition: transform 0.5s ease;
      }
    }

    .el-divider {
      background-color: rgba(255,255,255,0.4);
      height: 2px;
      margin: 15px 0;

      .el-divider__text {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        padding: 0;
        color: #fff;
        background: rgba(26, 117, 187, 0.8);
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .item-content {
      width: 360px;
      margin: 0 auto;
      padding: 15px;
      border-radius: 12px;
      background-color: rgba(255,255,255,0.08);
      backdrop-filter: blur(5px);
      transition: background-color 0.3s ease;

      h3 {
        font-size: 20px;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 10px;
      }

      p {
        font-size: 14px;
        height: 60px;
        overflow: hidden;
        margin: 0 0 12px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
        line-height: 1.6;
        color: rgba(255,255,255,0.85);
      }

      span {
        display: block;
        font-size: 13px;
        text-align: end;
        color: rgba(255,255,255,0.7);

        i {
          margin-right: 4px;
        }
      }

      h3 {
        color: #fff;
      }
    }
  }
}

.copyright {
  position: absolute;
  bottom: 20px;
  left: 20px;
  z-index: 999;
  color: #fff;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  opacity: 0.7;
}

/* 响应式设计 */
@media (max-width: 1240px) {
  .case-item {
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    padding: 0 30px;
  }

  .news-content {
    width: 100%;
    padding: 0 20px;
    flex-wrap: wrap;
  }
}

@media (max-width: 992px) {
  .case-item {
    grid-template-columns: repeat(2, 1fr);
    min-height: auto;
  }

  .swiper-slide .slogan {
    font-size: 36px;
    letter-spacing: 3px;
  }

  .swiper-slide .slogan-sub {
    font-size: 16px;
  }

  .swiper-slide .page h3 {
    font-size: 32px;
  }
}

@media (max-width: 768px) {
  .case-item {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
    padding: 0 15px;

    li {
      height: 120px;

      .case-item-title {
        font-size: 16px;
      }
    }
  }

  .news-content {
    flex-direction: column;
    align-items: center;
    gap: 20px;

    &-item {
      width: 100%;
      max-width: 360px;
    }
  }

  .swiper-slide .slogan {
    font-size: 28px;
    letter-spacing: 2px;
    padding: 10px 15px;
  }

  .copyright {
    display: none;
  }
}

@media (max-width: 480px) {
  .case-item {
    grid-template-columns: 1fr;
  }
}
</style>
